import { render } from "./TestColumnChart.vue?vue&type=template&id=026a3a59"
import script from "./TestColumnChart.vue?vue&type=script&lang=js"
export * from "./TestColumnChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__